import { ROOF_MEASUREMENT_KEYS } from "../../../constants/roofMeasurements";

type MeasurementEntry = {
    Calculated?: number;
    Actual?: number;
};

/** RHF mutates form state in place — clone so context gets a new reference. */
export function cloneMeasurements(
    measurements: Record<string, MeasurementEntry> = {},
) {
    const next: Record<string, { Calculated: number; Actual: number }> = {};

    for (const key of ROOF_MEASUREMENT_KEYS) {
        const entry = measurements[key];
        next[key] = {
            Calculated: Number(entry?.Calculated) || 0,
            Actual: Number(entry?.Actual) || 0,
        };
    }

    for (const [key, entry] of Object.entries(measurements)) {
        if (next[key]) continue;
        next[key] = {
            Calculated: Number(entry?.Calculated) || 0,
            Actual: Number(entry?.Actual) || 0,
        };
    }

    return next;
}
